export default __webpack_public_path__ + "static/media/359477993_786786816782943_2422070276806942141_n.af9b9682.jpg";